import axios from 'axios'
import { API_URL } from '../../../../constants'
import { IGeneralErrorObject } from '../../../../types'

/**
 * Meta-configuration of a routing context for the Adapter Routing Coverage map
 * (CPAYMENT-1485). Persists the configuration-level `enabled` flag (the
 * «Выключена» state) and the manual `order` used to sort the map list.
 *
 * Backend: POST /api/internal/payment-adapter/priority/config
 * (PostPaymentAdapterPriorityConfigController). The adapter priority list itself
 * is saved separately via postAdapterPriorities (POST /priority/).
 */
export interface IPostPriorityConfigReq {
  merchantToken: string
  paymentMethodType: string
  currency: string
  direction: string
  externalUserFlag: string
  source: string
  enabled?: boolean
  order?: number
}

export interface IPostPriorityConfigRes {
  success: boolean
  errors?: Partial<IGeneralErrorObject>
}

export const postPriorityConfig = (query: IPostPriorityConfigReq) =>
  axios.post<IPostPriorityConfigRes>(`${API_URL}/api/internal/payment-adapter/priority/config`, query)
